import { z } from 'zod';
import { PRODUCT_TYPE_SCHEMA } from '../../product-type/product-types.ts';

export const CUSTOM_REQUEST_PRODUCT_TYPES_SCHEMA = PRODUCT_TYPE_SCHEMA.extract([
    'CUSTOM_BULK_MATERIAL',
    'CUSTOM_RECYCLED_BULK_MATERIAL',
    'CUSTOM_CONCRETE',
    'CUSTOM_ASPHALT',
    'CUSTOM_NON_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_NON_HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_HAZARDOUS_WASTE_DISPOSAL',
    'CUSTOM_HAZARDOUS_WASTE_RECYCLING',
    'CUSTOM_TRANSPORT',
    'CUSTOM_SERVICE',
    'CUSTOM_SERVICE_ANALYSIS',
    'CUSTOM_SERVICE_ACCOMPANYING_DOCUMENT',
    'CUSTOM_SERVICE_TRANSPORT',
    'CUSTOM_SERVICE_TOLL',
    'CUSTOM_SERVICE_WAITING_TIME',
]);

export type CUSTOM_REQUEST_PRODUCT_TYPES = z.infer<typeof CUSTOM_REQUEST_PRODUCT_TYPES_SCHEMA>;
